
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ats/hire-and-analyze",
      function () {
        return require("private-next-pages/ats/hire-and-analyze/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ats/hire-and-analyze"])
      });
    }
  